import { type Components, type Theme } from "@mui/material/styles";

export const accordionDetails: Components<Theme>["MuiAccordionDetails"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: theme.palette.whiteStates.main,
    }),
  },
};
